import { type FC } from "react";
import { TextLink } from "@root/shared/components/TextLink";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { Colors } from "@root/shared/utils";
import * as styles from "./styles.css";

type Props = {
  isPayPerJobEntryFeeType: boolean;
  recruitmentFeePath: string;
};

export const Notice: FC<Props> = ({ isPayPerJobEntryFeeType, recruitmentFeePath }) => {
  if (isPayPerJobEntryFeeType) {
    return (
      <>
        <ul className={styles.formNoteCautionList}>
          <li className={styles.formNoteCautionListItem}>
            <span className={styles.formNoteIcon}>
              <Icon name="attention" fontSize="16px" color={Colors.DANGER} />
            </span>
            約款第19条に定める禁止事項に違反した場合、
            <span className={styles.formNoteStrong}>1名につき 違約金50万円</span>
            の支払い対象となります。
          </li>
        </ul>
        <GuidanceBox themeColor="yellow">
          <h3 className={styles.formNoteListHeading}>約款第19条（抜粋）</h3>
          <ul className={styles.formNoteList}>
            <li className={styles.formPayPerJobEntryNoteItem}>
              申込者は当社の許可なく、応募者を他の法人や個人、店舗、スクール、その他団体などに紹介、推薦又はこれに類する行為をしてはならない。
            </li>
          </ul>
          <p className={styles.formNoteRemarks}>
            その他、
            <TextLink
              href="https://relax-job.com/contents_list/client_contents/yakkan"
              target="_blank"
              rel="noreferrer noopener"
            >
              リジョブ利用約款
            </TextLink>
            第19条(禁止事項)をご確認ください。
          </p>
        </GuidanceBox>
      </>
    );
  }

  return (
    <>
      <ul className={styles.formNoteCautionList}>
        <li className={styles.formNoteCautionListItem}>
          <span className={styles.formNoteIcon}>
            <Icon name="attention" fontSize="16px" color={Colors.DANGER} />
          </span>
          虚偽の報告または採用報告義務に違反した場合、
          <span className={styles.formNoteStrong}>1名につき 違約金50万円</span>
          の支払い対象となります。
        </li>
      </ul>
      <GuidanceBox themeColor="yellow">
        <h3 className={styles.formNoteListHeading}>採用報告義務が発生するケース</h3>
        <ul className={styles.formNoteList}>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>雇用契約を結んだ。</span>
            <br />
            （面貸し、業務委託、業務提携などの契約形態を含む。）
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>雇用行為等を行ったが、早期退職した。</span>
            <br />
            （ご加入プランで定める返金期間にあたる場合、採用報告後、返金申請を行ってください。）
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>
              給与の発生有無に関わらず、入社に向けて何らかの理由で出社した。
            </span>
            <br />
            （研修のみ、練習のみ、技術指導のみ、試用期間のみ、体験入店のみの場合も対象。）
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>
              応募者がスクールや講習等に入校・受講等をした。
            </span>
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>
              リジョブ応募前に他経路からの応募があったが、リジョブを通して選考し、雇用行為等を行った。
            </span>
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>
              応募があった店舗では不採用にしたが、他の店舗で採用にした。
            </span>
          </li>
          <li className={styles.formNoteItem}>
            <span className={styles.formNoteListTitle}>
              リジョブで連絡先を取得後、応募日から
              <span className={styles.formNoteStrong}>2年以内</span>
              に再度応募があり、雇用行為等を行った。
            </span>
            <br />
            （一度辞退、不採用となった場合も含む。）
          </li>
        </ul>
        <p className={styles.formNoteRemarks}>
          その他、
          <TextLink
            href="https://relax-job.com/contents_list/client_contents/yakkan"
            target="_blank"
            rel="noreferrer noopener"
          >
            リジョブ利用約款
          </TextLink>
          第8条(成果報酬)・
          <TextLink href={recruitmentFeePath} target="_blank" rel="noreferrer noopener">
            雇用行為等
          </TextLink>
          をご確認ください。
        </p>
      </GuidanceBox>
    </>
  );
};
